import { Route } from "react-router-dom";
import Protected from "../../auth/Protected";
import { UserRole } from "../../../enums";
import GreetingOccasionsImagesPage from "./greeting-occasions-images-page";
 

export default (
  <Route path="greeting-occasions-images">
    <Route
      index
      element={
        <Protected
          path="/admin/greeting-occasions-images"
          roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}
        >
          <GreetingOccasionsImagesPage />
        </Protected>
      }
    />

    
  </Route>
);



